import { Component } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-alumnos-in',
  templateUrl: './alumnos-in.component.html',
  styleUrls: ['./alumnos-in.component.css']
})
export class AlumnosInComponent {

  apiURL = 'https://citsistemas3.uncu.edu.ar/internacionales/';

  formu: any = {
    dni: '',
    nombre: '',
    apellido: '',
    nacionalidad: '',
    correo: '',
    nro_celular: '',
    facebook: '',
    instagram: '',
    universidad_origen: '',
    facultad1: '',
    facultad2: '',
    convocatoria: '',
    id_convocatoria: ''
  };

  facultad = [
    {
      valor: '1',
      nombre: 'Facultad de Cs. Económicas'
    },
    {
      valor: '2',
      nombre: 'Facultad de Cs. Políticas y Sociales'
    },
    {
      valor: '3',
      nombre: 'Facultad de Cs. Médicas'
    },
    {
      valor: '4',
      nombre: 'Facultad de Ingeniería'
    },
    {
      valor: '5',
      nombre: 'Facultad de Odontología'
    },
    {
      valor: '6',
      nombre: 'Facultad de Artes y Diseño'
    },
    {
      valor: '7',
      nombre: 'Facultad de Filosofía y Letras'
    },
    {
      valor: '8',
      nombre: 'Facultad de Derecho'
    },
    {
      valor: '9',
      nombre: 'Facultad de Educación'
    },
    {
      valor: '10',
      nombre: 'Facultad de Cs. Agrarias'
    },
    {
      valor: '11',
      nombre: 'Facultad de Cs. Aplicadas a la Industria'
    },
    {
      valor: '12',
      nombre: 'Facultad de Cs. Exactas y Naturales'
    },
    {
      valor: '13',
      nombre: 'Inst. Tecnológico Universitario - ITU'
    }];

  resultado: '';

  procesar: boolean;

  constructor(private http: HttpClient) {
    this.consultarConvocatoria();
  }

  registrarse(formu) {

    const msj = 'Error al registrarse';
    const body = JSON.stringify(  { 'dni': this.formu.dni, 'nombre': this.formu.nombre, 'apellido': this.formu.apellido, 'nacionalidad': this.formu.nacionalidad,
                                          'correo': this.formu.correo, 'nro_celular': this.formu.nro_celular, 'facebook': this.formu.facebook, 'instagram': this.formu.instagram, 'universidad_origen': this.formu.universidad_origen, 'facultad1': this.formu.facultad1, 'facultad2': this.formu.facultad2, 'id_convocatoria': this.formu.id_convocatoria} );

    const promise = new Promise((resolve, reject) => {
      this.procesar = true;
      const apiURL = this.apiURL + '?ai=maca2||3474';
      this.http.post(apiURL, body)
        .subscribe(
          (res: any) => {
             console.log(res);
            this.procesar = false;
            this.resultado = res.registro;
          },
          msg => {
            reject(msj);
            this.procesar = false;
            this.resultado = '';
          });
    });
    return promise;
  }

  consultarConvocatoria(){
    var msjError = "Error al obtener la convocatoria";
    let promise = new Promise((resolve, reject) => {
      let apiURL = this.apiURL + "?ai=maca2||3472";
      this.http.get(apiURL, {})
        .subscribe(
          (res:any) =>{
            this.formu.convocatoria = res.descripcion;
            this.formu.id_convocatoria = res.id_convocatoria;
            console.log(res);
          },
          msg => {
            console.log(msjError);
            reject(msjError);
          });
    });
    return promise;
  }

}
